<template>
  <v-toolbar height="80" color="rgba(0,0,0, 0)">
    <v-img :src="loadImage('animated_logo.svg')"></v-img>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>
<style scoped>
@import '../assets/main.css';
</style>
<script>
export default {
  name: "FrontpageToolbar"
}
</script>